import React from 'react';
import { Box } from '@mui/material';
import { WcnCheckbox } from '@/components';
import { StatusTag } from '@/components/shared/Tags.tsx';
import type { OperationMode } from '@/services';
import { useModeTagState } from '@core/hooks/useModeTagState.ts';

interface ActiveOperationModesFieldsProps {
    operationModes: OperationMode[];
    activeOperationModes: string[];
    onActiveOperationModesChange: (modes: string[]) => void;
}

const ActiveOperationModesFields: React.FC<ActiveOperationModesFieldsProps> = ({
    operationModes,
    activeOperationModes,
    onActiveOperationModesChange
}) => {
    const toggleActiveOperationMode = (modeName: string, checked: boolean) => {
        const updated = checked
            ? [...activeOperationModes, modeName]
            : activeOperationModes.filter((m) => m !== modeName);
        onActiveOperationModesChange(updated);
    };

    const getModeTagState = useModeTagState();

    return (
        <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {operationModes.map((mode) => (
                    <Box key={mode.id} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <WcnCheckbox
                            checked={activeOperationModes.includes(mode.name)}
                            onChange={(e) => toggleActiveOperationMode(mode.name, e.target.checked)}
                            className="wcn-checkbox--16"
                        />
                        <StatusTag state={getModeTagState(mode.name)} label={mode.name} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default ActiveOperationModesFields;
